import {LitElement, html, TemplateResult} from 'lit';
import {getFormJSON} from './forms';
/**
 * `product-sync-section`
 */
export class ProductSyncSection extends LitElement {
  /**
   * Render in the light dom
   *
   * @returns {object} this
   */
  createRenderRoot() {
    return this;
  }

  /**
   * Defined the elements content
   *
   * @returns {TemplateResult} the resulting html template
   */
  render() {
    return html`
        <form name="productSync" @submit=${this._submit}>
          <label>
            What email address should notify?
            <input name="email" type="email" required placeholder="Example: user@company.com">
          </label>
          <div class="buttons">
            <button type="submit">Sync Products</button>
            <button type="reset">Clear</button>
          </div>
          <div class="status">
            <p ?hidden=${!this.isSavingComplete}>Product sync job created.</p>
            <p ?hidden=${!this.isSavingError}>Error creating your product sync job.</p>
            <p ?hidden=${!this.isSaving}>Saving product sync job...</p>
          </div>
        </form>`;
  }

  /**
   * Defines the elements properties
   *
   * @returns {object} the elements properties
   */
  static get properties() {
    return {
      /** Used to interact with api */
      service: {type: Object},
      /** Auth email address */
      email: {type: String},
      /** If we are saving data */
      isSaving: {type: Boolean},
      /** If there is an error saving data*/
      isSavingError: {type: Boolean},
      /** If we have saved data */
      isSavingComplete: {type: Boolean},
    };
  }

  /** Initialises values of properties */
  constructor() {
    super();
    this.service = {};
    this.email = '';
    this.isSaving = false;
    this.isSavingError = false;
    this.isSavingComplete = false;
  }

  /**
   * Trigger the product sync
   *
   * @param {object} event the form save event
   */
  async _submit(event) {
    event.preventDefault();
    this.isSaving = false;
    this.isSavingError = false;
    const form = this.querySelector('form[name="productSync"]');
    const valid = form.reportValidity();
    if (valid) {
      try {
        this.isSaving = true;
        const data = getFormJSON(form);
        if (!data.email) {
          throw new Error(`no email address provided`);
        }
        await this.service.createJob('products', 'sync', data.email);
        this.isSaving = false;
        this.isSavingComplete = true;
      } catch (e) {
        this.isSaving = false;
        this.isSavingError = true;
      } finally {
        await new Promise((resolve) => setTimeout(resolve, 3000));
        this.isSaving = false;
        this.isSavingError = false;
        this.isSavingComplete = false;
      }
    }
  }
}
window.customElements.define('product-sync-section', ProductSyncSection);
